import { ActivityChart } from "./ActivityChart";
import { ActivityFilter } from "./ActivityFilter";
import { AdoptionSummary } from "./AdoptionSummary";

export function Activity() {
  return (
    <div className="flex flex-col gap-5">
      <ActivityFilter />
      <ActivityChart />
      <AdoptionSummary />
    </div>
  );
}
